'use client';

import { ChevronLeft, ChevronRight } from 'lucide-react';

import { Button } from '@kit/ui/button';
import { Trans } from '@kit/ui/trans';

interface DocumentNavigatorProps {
  currentIndex: number;
  totalDocuments: number;
  onNavigate: (direction: 'prev' | 'next') => void;
  hasPrevious: boolean;
  hasNext: boolean;
}

export function DocumentNavigator({
  currentIndex,
  totalDocuments,
  onNavigate,
  hasPrevious,
  hasNext,
}: DocumentNavigatorProps) {
  if (totalDocuments <= 1) return null;

  return (
    <div className="bg-muted/30 flex items-center justify-between border-b p-4">
      <Button
        variant="outline"
        size="sm"
        onClick={() => onNavigate('prev')}
        disabled={!hasPrevious}
      >
        <ChevronLeft className="mr-1 h-4 w-4" />
        <Trans i18nKey="common:previous" />
      </Button>

      <span className="text-muted-foreground text-sm">
        {currentIndex + 1} / {totalDocuments}
      </span>

      <Button
        variant="outline"
        size="sm"
        onClick={() => onNavigate('next')}
        disabled={!hasNext}
      >
        <Trans i18nKey="common:next" />
        <ChevronRight className="ml-1 h-4 w-4" />
      </Button>
    </div>
  );
}
